import { FeeDetailDTO } from "@models/platform-analysis/entities/steps/fee";
import { View } from "@react-pdf/renderer";
import { useTheme } from "@mui/material";
import { PDFStyleConfigs } from "../../../configs";
import { FeeAnalysisLabelConstants } from "@pages/platform-analysis-v2/_id/steps/fee/analysis/constants";
import { calculateFeeDetailColumnWidth } from "../../../utils";

export const PDFVerticalDashLineDetail = ({
  firstProductFeeDetails,
  hasTooManyFeeColumns = false,
}: {
  firstProductFeeDetails: FeeDetailDTO[];
  hasTooManyFeeColumns: boolean;
}) => {
  const { palette } = useTheme();
  const contentWidth = hasTooManyFeeColumns
    ? PDFStyleConfigs.FeeAnalysisFeeDetailContentWidthWithoutLogo
    : PDFStyleConfigs.FeeAnalysisFeeDetailContentWidth;

  const { pysColumnWidth, otherColumnWidth } = calculateFeeDetailColumnWidth(
    contentWidth,
    firstProductFeeDetails,
  );

  return (
    <View
      style={{
        flexDirection: "row",
        paddingLeft: 3,
        height: 3,
      }}
    >
      {firstProductFeeDetails.map((feeDetail, index) => {
        const isPYSColumn =
          feeDetail.name === FeeAnalysisLabelConstants.PYSRefund;

        return (
          <View
            key={index}
            style={{
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              marginRight: index === 0 ? "5px" : "1.5px",
              marginLeft:
                index === firstProductFeeDetails.length - 1 ? "5px" : "1.5px",
              width: isPYSColumn ? pysColumnWidth : otherColumnWidth,
              height: 3,
            }}
          >
            {index !== firstProductFeeDetails.length - 1 && (
              <View
                style={{
                  backgroundColor: palette.text.primary,
                  width: 0.5,
                  height: 3,
                  marginLeft:
                    index === 0
                      ? "-1px"
                      : index === 1
                      ? "-4px"
                      : index === firstProductFeeDetails.length - 1
                      ? "-6px"
                      : "-2px",
                }}
              />
            )}
            {index === firstProductFeeDetails.length - 1 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <View
                  style={{
                    backgroundColor: palette.text.primary,
                    width: 0.5,
                    height: 3,
                    marginLeft: "-4px",
                  }}
                />
                <View
                  style={{
                    backgroundColor: palette.text.primary,
                    width: 0.5,
                    height: 3,
                    marginRight: "0px",
                  }}
                />
              </View>
            )}
          </View>
        );
      })}
    </View>
  );
};
